var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyWorkspaceFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 86,
    viewBox: "0 0 152 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84,
    clipPath: "url(#clip0_8686_9318)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.671 19.5C149.166 19.5 152 22.3654 152 25.9C152 29.4346 149.166 32.3 145.671 32.3H109.503C112.999 32.3 115.832 35.1654 115.832 38.7C115.832 42.2346 112.999 45.1 109.503 45.1H129.395C132.891 45.1 135.725 47.9654 135.725 51.5C135.725 55.0346 132.891 57.9 129.395 57.9H120.196C115.789 57.9 112.216 60.7654 112.216 64.3C112.216 65.7829 112.932 67.1774 114.364 68.4837C116.288 70.2386 119.246 70.3739 121.348 71.912C122.936 73.0747 123.97 74.9653 123.97 77.1C123.97 80.6346 121.136 83.5 117.641 83.5H42.5928C39.0972 83.5 36.2635 80.6346 36.2635 77.1C36.2635 73.5654 39.0972 70.7 42.5928 70.7H7.32934C3.83374 70.7 1 67.8346 1 64.3C1 60.7654 3.83374 57.9 7.32934 57.9H43.497C46.9926 57.9 49.8263 55.0346 49.8263 51.5C49.8263 47.9654 46.9926 45.1 43.497 45.1H20.8922C17.3966 45.1 14.5629 42.2346 14.5629 38.7C14.5629 35.1654 17.3966 32.3 20.8922 32.3H57.0599C53.5643 32.3 50.7305 29.4346 50.7305 25.9C50.7305 22.3654 53.5643 19.5 57.0599 19.5H145.671ZM145.671 45.1C149.166 45.1 152 47.9654 152 51.5C152 55.0346 149.166 57.9 145.671 57.9C142.175 57.9 139.341 55.0346 139.341 51.5C139.341 47.9654 142.175 45.1 145.671 45.1Z",
    fill: "#EFECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8476 16.6146L98.3504 64.6698L98.9346 69.491C99.1228 71.0441 98.0327 72.4578 96.4999 72.6485L55.562 77.7416C54.0291 77.9323 52.6339 76.8278 52.4457 75.2747L46.143 23.2635C46.0489 22.487 46.594 21.7801 47.3604 21.6848C47.3652 21.6842 47.3701 21.6836 47.3749 21.683L50.7713 21.297L91.8476 16.6146ZM53.5176 20.9849L56.7243 20.6204L53.5176 20.9849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5176 20.9849L56.7243 20.6204M91.8476 16.6146L98.3504 64.6698L98.9346 69.491C99.1228 71.0441 98.0327 72.4578 96.4999 72.6485L55.562 77.7416C54.0291 77.9323 52.6339 76.8278 52.4457 75.2747L46.143 23.2635C46.0489 22.487 46.594 21.7801 47.3604 21.6848C47.3652 21.6842 47.3701 21.6836 47.3749 21.683L50.7713 21.297L91.8476 16.6146Z",
    stroke: "#5C41FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0804 19.6387L95.9663 63.1896L96.4957 67.5588C96.6663 68.9663 95.6918 70.2458 94.3191 70.4166L57.6583 74.9776C56.2856 75.1484 55.0345 74.1458 54.8639 72.7382L49.1665 25.7215C49.0724 24.945 49.6174 24.2381 50.3838 24.1428L54.9191 23.5785",
    fill: "#EFECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6372 7.5835H61.7896C61.2588 7.5835 60.7782 7.80153 60.4303 8.15403C60.0824 8.50653 59.8672 8.99351 59.8672 9.53141V63.3647C59.8672 63.9026 60.0824 64.3896 60.4303 64.7421C60.7782 65.0946 61.2588 65.3127 61.7896 65.3127H103.035C103.566 65.3127 104.047 65.0946 104.394 64.7421C104.742 64.3896 104.957 63.9026 104.957 63.3647V19.0478C104.957 18.531 104.755 18.0353 104.394 17.67L94.9962 8.1536C94.6357 7.78856 94.1469 7.5835 93.6372 7.5835Z",
    fill: "white",
    stroke: "#5C41FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9453 8.3999V16.6146C93.9453 17.7882 94.8843 18.7396 96.0425 18.7396H101.589",
    stroke: "#5C41FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3828 54.8647H85.5587M67.3828 18.7397H85.5587H67.3828ZM67.3828 27.2397H97.443H67.3828ZM67.3828 36.4481H97.443H67.3828ZM67.3828 45.6564H97.443H67.3828Z",
    stroke: "#5C41FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8686_9318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 85,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWorkspaceFileIcon);
export default __webpack_public_path__ + "static/media/EmptyWorkspaceFileIcon.dd74f92c6c325287e4d50298049f5656.svg";
export { ForwardRef as ReactComponent };